<template>
  <div>
    <div class="lg:py-12 md:py-12 py-8 lg:px-20 md:px-12 px-5">
      <div class="text-center lg:w-1/2 md:w-3/4 w-full mx-auto">
        <h2 class="fsize30 sm-fsize24 font-semibold mb-2 clr-black">
          How We Can Help
        </h2>
        <p class="lg:mb-4 md:mb-4 mb-2 sm-fsize14">
          Our services are designed to cater to your company’s and employees
          specific needs and goals.
        </p>
      </div>
      <!-- Left -->
      <div
        class="lg:flex md:flex w-full sm-reverse items-center container mx-auto lg:py-8 md:py-8 py-4"
      >
        <div class="lg:w-1/2 md:w-full lg:pr-10 lg:my-0 md:my-0 my-4">
          <h2
            class="fsize32 md-fsize20 sm-fsize18 font-semibold text-primary lg:mb-4 md:mb-4 mb-2"
          >
            Corporate Advisory Support Services for Caregiver Well-being.
          </h2>
          <div class="flex gap-4">
            <div>
              <feather-icon
                icon="HeartIcon"
                class="clr-786ACE"
                svgClasses="w-5 h-5 ml-1 mt-2"
              ></feather-icon>
            </div>
            <div>
              <p class="fsize20 md-fsize18 sm-fsize16 font-semibold text-black">
                Advisory on Caregiver Policies and Best Practices
              </p>
              <p class="sm-fsize14">
                We will partner with you to conduct a diagnostic assessment to
                help develop and implement policies that support caregivers and
                caregiving within your organization.
              </p>
            </div>
          </div>
          <div class="flex gap-4 my-4">
            <div>
              <feather-icon
                icon="HeartIcon"
                class="clr-786ACE"
                svgClasses="w-5 h-5 ml-1 mt-2"
              ></feather-icon>
            </div>
            <div>
              <p class="fsize20 md-fsize18 sm-fsize16 font-semibold text-black">
                EAP Counseling Services
              </p>
              <p class="sm-fsize14">
                Our program connects caregivers with professionals and Employee
                Assistance Programs (EAPs), providing them with the necessary
                support and resources.
              </p>
            </div>
          </div>
          <div @click="toForm" class="mt-4">
            <button class="flex items-center clr4F0A4B sm-fsize14 mt-2">
              <a
                href="#getACallBack"
                v-smooth-scroll="{ duration: 1000, offset: -10 }"
                class="flex items-center"
              >
                Reach out to us
                <feather-icon
                  icon="ArrowRightIcon"
                  class=""
                  svgClasses="w-4 h-4 ml-1"
                ></feather-icon>
              </a>
            </button>
          </div>
        </div>
        <div class="lg:w-1/2 md:w-full w-full lg:pl-10 md:pl-10">
          <div class="w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/Rectangle%20149.png"
              class="chua-img tb-h280px object-contain w-full"
              alt="img"
            />
          </div>
        </div>
      </div>
      <!-- Right -->
      <div
        class="lg:flex md:flex items-center container mx-auto lg:py-8 md:py-8 py-6"
      >
        <div class="lg:w-1/2 md:w-full lg:pr-4 md:pr-10">
          <div class="w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/Frame%20722.png"
              class="chua-img tb-h280px object-contain w-full"
              alt="img"
            />
          </div>
        </div>

        <div class="lg:w-1/2 md:w-full lg:pr-10 lg:my-0 md:my-0 my-4">
          <h2
            class="fsize32 md-fsize20 sm-fsize18 font-semibold text-primary lg:mb-4 md:mb-4 mb-2"
          >
            Employee Well-being Services
          </h2>
          <div class="flex gap-4">
            <div>
              <feather-icon
                icon="HeartIcon"
                class="clr-786ACE"
                svgClasses="w-5 h-5 ml-1 mt-2"
              ></feather-icon>
            </div>
            <div>
              <p
                class="fsize20 md-fsize18 sm-fsize16 font-semibold text-black flex items-center gap-2 cursor-pointer"
                @click="handleRedirect()"
              >
                ISBA Audit
                <feather-icon
                  icon="ExternalLinkIcon"
                  class=""
                  svgClasses="w-4 h-4 flex"
                ></feather-icon>
                <span class="blink_me">New</span>
              </p>
              <p class="sm-fsize14">
                Our proprietary tool, designed by Caregiver Saathi, offers a
                comprehensive assessment of stress levels and burnout risk,
                enabling proactive well-being management for individuals.
              </p>
            </div>
          </div>
          <div class="flex gap-4 my-4">
            <div>
              <feather-icon
                icon="HeartIcon"
                class="clr-786ACE"
                svgClasses="w-5 h-5 ml-1 mt-2"
              ></feather-icon>
            </div>
            <div>
              <p class="fsize20 md-fsize18 sm-fsize16 font-semibold text-black">
                Home Care Solutions and Resources Directory
              </p>
              <p class="sm-fsize14">
                Offering a comprehensive directory of home care services and
                resources to ease the caregiving burden for employees
              </p>
            </div>
          </div>
          <div class="flex gap-4 my-4">
            <div>
              <feather-icon
                icon="HeartIcon"
                class="clr-786ACE"
                svgClasses="w-5 h-5 ml-1 mt-2"
              ></feather-icon>
            </div>
            <div>
              <p class="fsize20 md-fsize18 sm-fsize16 font-semibold text-black">
                Financial, Legal, and Inheritance Advisory
              </p>
              <p class="sm-fsize14">
                Provide your employees with expert guidance and support in
                financial planning, legal matters, and inheritance-related
                concerns
              </p>
            </div>
          </div>
          <div class="flex gap-4 my-4">
            <div>
              <feather-icon
                icon="HeartIcon"
                class="clr-786ACE"
                svgClasses="w-5 h-5 ml-1 mt-2"
              ></feather-icon>
            </div>
            <div>
              <p class="fsize20 md-fsize18 sm-fsize16 font-semibold text-black">
                Experience Center
              </p>
              <p class="sm-fsize14">
                Visit our experience centre to explore interactive displays and
                educational resources focused on employee well-being and
                caregiving support
              </p>
            </div>
          </div>
          <div @click="toForm" class="mt-4">
            <button class="flex items-center clr4F0A4B sm-fsize14 mt-2">
              <a
                href="#getACallBack"
                v-smooth-scroll="{ duration: 1000, offset: -10 }"
                class="flex items-center"
              >
                Reach out to us
                <feather-icon
                  icon="ArrowRightIcon"
                  class=""
                  svgClasses="w-4 h-4 ml-1"
                ></feather-icon>
              </a>
            </button>
          </div>
        </div>
      </div>
      <!-- Left -->
      <div
        class="lg:flex md:flex w-full sm-reverse items-center container mx-auto lg:py-8 md:py-8 py-4"
      >
        <div class="lg:w-1/2 md:w-full lg:pr-10 lg:my-0 md:my-0 my-4">
          <h2
            class="fsize32 md-fsize20 sm-fsize18 font-semibold text-primary lg:mb-4 md:mb-4 mb-2"
          >
            Learning Interventions
          </h2>
          <div class="flex gap-4">
            <div>
              <feather-icon
                icon="HeartIcon"
                class="clr-786ACE"
                svgClasses="w-5 h-5 ml-1 mt-2"
              ></feather-icon>
            </div>
            <div>
              <p class="fsize20 md-fsize18 sm-fsize16 font-semibold text-black">
                Programs for Individuals
              </p>
              <p class="sm-fsize14">
                Engage in learning tools and workshops focusing on well-being,
                resilience, and recovery to empower your employees to navigate
                life's challenges with confidence
              </p>
            </div>
          </div>
          <div class="flex gap-4 my-4">
            <div>
              <feather-icon
                icon="HeartIcon"
                class="clr-786ACE"
                svgClasses="w-5 h-5 ml-1 mt-2"
              ></feather-icon>
            </div>
            <div>
              <p class="fsize20 md-fsize18 sm-fsize16 font-semibold text-black">
                Programs for Leaders
              </p>
              <p class="sm-fsize14">
                Elevate leadership capabilities with specialised training in
                compassionate leadership, effective management of workplace
                grief, and the integration of caregiver support into your
                organisational culture.
              </p>
            </div>
          </div>
          <div @click="toForm" class="mt-4">
            <button class="flex items-center clr4F0A4B sm-fsize14 mt-2">
              <a
                href="#getACallBack"
                v-smooth-scroll="{ duration: 1000, offset: -10 }"
                class="flex items-center"
              >
                Reach out to us
                <feather-icon
                  icon="ArrowRightIcon"
                  class=""
                  svgClasses="w-4 h-4 ml-1"
                ></feather-icon>
              </a>
            </button>
          </div>
        </div>
        <div class="lg:w-1/2 md:w-full w-full lg:pl-10 md:pl-10">
          <div class="w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/Rectangle%20148.png"
              class="chua-img tb-h280px object-contain w-full"
              alt="img"
            />
          </div>
        </div>
      </div>
      <!-- Right -->
      <div
        class="lg:flex md:flex items-center container mx-auto lg:py-8 md:py-8 py-6"
      >
        <div class="lg:w-1/2 md:w-full lg:pr-4 md:pr-10">
          <div class="w-full">
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/image%20(8).png"
              class="chua-img tb-h280px object-contain w-full"
              alt="img"
            />
          </div>
        </div>

        <div class="lg:w-1/2 md:w-full lg:pr-10 lg:my-0 md:my-0 my-4">
          <h2
            class="fsize32 md-fsize20 sm-fsize18 font-semibold text-primary lg:mb-4 md:mb-4 mb-2"
          >
            ESG/CSR Initiatives
          </h2>
          <div class="flex gap-4">
            <div>
              <feather-icon
                icon="HeartIcon"
                class="clr-786ACE"
                svgClasses="w-5 h-5 ml-1 mt-2"
              ></feather-icon>
            </div>
            <div>
              <p class="fsize20 md-fsize18 sm-fsize16 font-semibold text-black">
                Home Care Solutions and Resources Directory
              </p>
              <p class="sm-fsize14">
                Offering a comprehensive directory of home care services and
                resources to ease the caregiving burden for employees
              </p>
            </div>
          </div>
          <div class="flex gap-4 my-4">
            <div>
              <feather-icon
                icon="HeartIcon"
                class="clr-786ACE"
                svgClasses="w-5 h-5 ml-1 mt-2"
              ></feather-icon>
            </div>
            <div>
              <p class="fsize20 md-fsize18 sm-fsize16 font-semibold text-black">
                Research, Advocacy, and Awareness
              </p>
              <p class="sm-fsize14">
                Drive research, advocacy, and awareness initiatives focused on
                palliative care within communities, particularly targeting
                marginalised groups through outreach programs.
              </p>
            </div>
          </div>

          <div @click="toForm" class="mt-4">
            <button class="flex items-center clr4F0A4B sm-fsize14 mt-2">
              <a
                href="#getACallBack"
                v-smooth-scroll="{ duration: 1000, offset: -10 }"
                class="flex items-center"
              >
                Reach out to us
                <feather-icon
                  icon="ArrowRightIcon"
                  class=""
                  svgClasses="w- h-4 ml-1"
                ></feather-icon>
              </a>
            </button>
          </div>
        </div>
      </div>

      <div class="flex justify-center lg:mt-12 md:mt-10 mt-6">
        <button
          class="rounded-full py-2 px-4 bg4F0A4B clr-fff"
          @click="handleScroll"
        >
          <a
            href="#getACallBack"
            v-smooth-scroll="{ duration: 1000, offset: -10 }"
          >
            Get a Call Back
          </a>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    handleRedirect() {
      // this.$router.push({
      //   name: "friends-caregiversaathi",
      // });
      window.open("https://isba.caregiversaathi.co.in/", "_blank");
    },
    toForm() {
      const ele = document.getElementById("corporateForm");
      ele.scrollIntoView({ behavior: "smooth" });
    },
    handleScroll() {
      const el = document.getElementById("corporateForm");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
    },
  },
  computed: {},
  mounted() {},
};
</script>
<style>
.chua-img {
  width: 100% !important;
  height: 450px !important;

  @media (max-width: 640px) {
    height: 250px !important;
  }
}
@media (max-width: 768px) and (min-width: 641px) {
  .tb-h280px {
    height: 280px !important;
  }
}
.clr-786ACE {
  color: #786ace;
}
</style>
